import { render, staticRenderFns } from "./TaValArea.vue?vue&type=template&id=010fd74e&"
import script from "./TaValArea.vue?vue&type=script&lang=js&"
export * from "./TaValArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports